import { Box, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material"
import { useAppSelector } from "../../../../application/states/hooks"
import { useSettingsService } from "../../../../use-cases/settings"
import { theme } from "../../../styles"
import ProfileIcon from '@mui/icons-material/AccountCircle';
import SecurityIcon from '@mui/icons-material/Security';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { ProfileSection } from "./profile-section";
import { SecuritySection } from "./security-section";
import { UserSection } from "./users-section";
import { useEffect } from "react";
import SyncLockIcon from '@mui/icons-material/SyncLock';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { ConsumptionLockSection } from "./consumption-lock-section";
import { WhiteLabelSection } from "./white-label-section";
import { useUserService } from "../../../../use-cases/user";
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { IntegrationSection } from "./crm-section/integrationSection";
import { FaqsSection } from "./faqs-section";
import { HelpSection } from "./help-section";

export const SettingsPage = () => {
  // States
  const activeTab = useAppSelector((state) => state.settings.activeTab)
  const userType = useAppSelector((state) => state.user.userType)
  const { company } = useAppSelector((state) => state.company)
  const { resaleConfig } = useAppSelector((state) => state.resaleConfig)
  // Service
  const { setActiveTab } = useSettingsService()
  const { setUserList } = useUserService()

  useEffect(() => {
    document.title = `${resaleConfig?.id !== '' ? `${resaleConfig!.name}` : 'Lurik'} - Configurações`
  }, [resaleConfig])

  useEffect(() => {
    if (userType === 'ADMIN' || userType === 'OWNER') {
      setUserList()
    }
  }, [setUserList, userType])

  return <>
    <Box p={3}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <List>
            <ListItem>
              <Paper elevation={3} style={{
                width: '100%'
              }}>
                <ListItemButton onClick={() => {
                  setActiveTab({
                    tab: 'profile'
                  })
                }} style={{
                  background: activeTab === 'profile' ? theme.palette.primary.main : '',
                  color: activeTab === 'profile' ? 'white' : 'black',
                }}>
                  <ListItemIcon>
                    <ProfileIcon style={{
                      color: activeTab === 'profile' ? 'white' : 'black',
                    }} />
                  </ListItemIcon>
                  <ListItemText primary="PERFIL" />
                </ListItemButton>
              </Paper>
            </ListItem>
            <ListItem disablePadding sx={{ px: 2, pt: 2, pb: 1 }}>
              <Typography variant="h6" sx={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>
                Configurações
              </Typography>
            </ListItem>
            <ListItem>
              <Paper elevation={3} style={{
                width: '100%'
              }}>
                <ListItemButton onClick={() => {
                  setActiveTab({
                    tab: 'security'
                  })
                }} style={{
                  background: activeTab === 'security' ? theme.palette.primary.main : '',
                  color: activeTab === 'security' ? 'white' : 'black',
                }}>
                  <ListItemIcon>
                    <SecurityIcon style={{
                      color: activeTab === 'security' ? 'white' : 'black',
                    }} />
                  </ListItemIcon>
                  <ListItemText primary="SEGURANÇA" />
                </ListItemButton>
              </Paper>
            </ListItem>
            {
              (userType === 'ADMIN' || userType === 'OWNER') ? (
                <>
                  <ListItem>
                    <Paper elevation={3} style={{
                      width: '100%'
                    }}>
                      <ListItemButton onClick={() => {
                        setActiveTab({
                          tab: 'users'
                        })
                      }} style={{
                        background: activeTab === 'users' ? theme.palette.primary.main : '',
                        color: activeTab === 'users' ? 'white' : 'black',
                      }}>
                        <ListItemIcon>
                          <GroupAddIcon style={{
                            color: activeTab === 'users' ? 'white' : 'black',
                          }} />
                        </ListItemIcon>
                        <ListItemText primary="USUÁRIOS" />
                      </ListItemButton>
                    </Paper>
                  </ListItem>
                  <ListItem>
                    <Paper elevation={3} style={{
                      width: '100%'
                    }}>
                      <ListItemButton onClick={() => {
                        setActiveTab({
                          tab: 'consumptionLock'
                        })
                      }} style={{
                        background: activeTab === 'consumptionLock' ? theme.palette.primary.main : '',
                        color: activeTab === 'consumptionLock' ? 'white' : 'black',
                      }}>
                        <ListItemIcon>
                          <SyncLockIcon style={{
                            color: activeTab === 'consumptionLock' ? 'white' : 'black',
                          }} />
                        </ListItemIcon>
                        <ListItemText primary="TRAVA DE CONSUMO" />
                      </ListItemButton>
                    </Paper>
                  </ListItem>
                  <ListItem>
                    <Paper elevation={3} style={{ width: '100%' }}>
                      <ListItemButton
                        onClick={() => setActiveTab({ tab: 'integration' })}
                        style={{
                          background: activeTab === 'integration' ? theme.palette.primary.main : '',
                          color: activeTab === 'integration' ? 'white' : 'black',
                        }}
                      >
                        <ListItemIcon>
                          <IntegrationInstructionsIcon style={{ color: activeTab === 'integration' ? 'white' : 'black' }} />
                        </ListItemIcon>
                        <ListItemText primary="INTEGRAÇÕES | CRM" />
                      </ListItemButton>
                    </Paper>
                  </ListItem>
                  {
                    company?.resale === true ?
                      <>
                        <ListItem>
                          <Paper elevation={3} style={{
                            width: '100%'
                          }}>
                            <ListItemButton onClick={() => {
                              setActiveTab({
                                tab: 'whiteLabel'
                              })
                            }} style={{
                              background: activeTab === 'whiteLabel' ? theme.palette.primary.main : '',
                              color: activeTab === 'whiteLabel' ? 'white' : 'black',
                            }}>
                              <ListItemIcon>
                                <AutoFixHighIcon style={{
                                  color: activeTab === 'whiteLabel' ? 'white' : 'black',
                                }} />
                              </ListItemIcon>
                              <ListItemText primary={"White Label".toUpperCase()} />
                            </ListItemButton>
                          </Paper>
                        </ListItem>
                      </>
                      : null
                  }
                </>
              ) : null
            }
            <ListItem disablePadding sx={{ px: 2, pt: 2, pb: 1 }}>
              <Typography variant="h6" sx={{ color: theme.palette.primary.main, fontWeight: 'bold' }}>
                Ajuda
              </Typography>
            </ListItem>
            <ListItem>
              <Paper elevation={3} style={{ width: '100%' }}>
                <ListItemButton
                  onClick={() => setActiveTab({ tab: 'faqs' })}
                  style={{
                    background: activeTab === 'faqs' ? theme.palette.primary.main : '',
                    color: activeTab === 'faqs' ? 'white' : 'black',
                  }}
                >
                  <ListItemIcon>
                    <QuestionAnswerIcon style={{ color: activeTab === 'faqs' ? 'white' : 'black' }} />
                  </ListItemIcon>
                  <ListItemText primary="PERGUNTAS FREQUENTES" />
                </ListItemButton>
              </Paper>
            </ListItem>
            {company?.resale !== true && !company?.resaleId ? (
              <ListItem>
                <Paper elevation={3} style={{ width: '100%' }}>
                  <ListItemButton
                    onClick={() => setActiveTab({ tab: 'help' })}
                    style={{
                      background: activeTab === 'help' ? theme.palette.primary.main : '',
                      color: activeTab === 'help' ? 'white' : 'black',
                    }}
                  >
                    <ListItemIcon>
                      <HelpOutlineIcon style={{ color: activeTab === 'help' ? 'white' : 'black' }} />
                    </ListItemIcon>
                    <ListItemText primary="MANUAL LURIK 360°" />
                  </ListItemButton>
                </Paper>
              </ListItem>
            ) : null}

          </List>
        </Grid>
        <Grid item xs={9}>
          <Box p={2}>

            {
              activeTab === 'profile' ? (
                <>
                  <ProfileSection />
                </>
              ) : null
            }
            {
              activeTab === 'integration' ? (
                <IntegrationSection />
              ) : null
            }
            {
              activeTab === 'security' ? (
                <>
                  <SecuritySection />
                </>
              ) : null
            }
            {
              activeTab === 'users' && (userType === 'ADMIN' || userType === 'OWNER') ? (
                <>
                  <UserSection />
                </>
              ) : null
            }
            {
              activeTab === 'consumptionLock' && (userType === 'ADMIN' || userType === 'OWNER') ? (
                <>
                  <ConsumptionLockSection />
                </>
              ) : null
            }
            {
              activeTab === 'whiteLabel' && (userType === 'ADMIN' || userType === 'OWNER') ? (
                <>
                  <WhiteLabelSection />
                </>
              ) : null
            }
            {activeTab === 'faqs' ? <FaqsSection /> : null}
            {activeTab === 'help' && company?.resale !== true && !company?.resaleId ? <HelpSection /> : null}
          </Box>
        </Grid>
      </Grid>
    </Box>
  </>
}